import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import FileService from "../../../services/fileService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ContactService from "../../../services/contactService";
import _ from "lodash";
import FormInput from "../../../components/common/form/FormInput";
import {
  CompanyPermissions,
  ContactPermissions,
  ContentPermissions,
} from "../../../services/permissions";
import formatFrontendDate from "../util/formatFrontendDate";
import {
  FaFile,
  FaFolder,
  FaShare,
  FaTrash,
  FaUpload,
  FaUserMinus,
} from "react-icons/fa";
import FileUploadButton from "../../../components/drive/FileUploadButton";
import fileService from "../../../services/fileService";
import Loader from "../../Loader";
import downloadUtil from "../../../util/downloadUtil";
import SecurityService from "../../../services/securityService";
import FormReactSelect from "../../../components/common/form/FormReactSelect";
import { countries } from "../../../util/countries";
import UtilService from "../../../services/utilService";

class MyDrive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      filterName: null,
      filterCountry: null,
      filteredList: [],
      alert: null,
      loading: false,
      renameModal: false,
      newName: "",
      shareWith: [],
      unShareWith: [],
      selectedFileItem: null,
      shareModal: false,
      contactModal: false,
      viewSharedModal: false,
      contactList: [],
      sharedWithList: [],
      filteredContacts: [],
      parentFolderId: this.props.match.params.uniqueId || null,
      fileList: new Set(),
      isBulkShare: false,
      selectKey: UtilService.uuidv4(),
      selectedSharedUser: null,
      allSharedUsers: [],
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  loadData = () => {
    if (this.state.parentFolderId !== null) {
      FileService.myFilesInFolder(this.state.parentFolderId).then(
        (response) => {
          const emailMap = new Map();

          for (let fileItem of response) {
            if (Array.isArray(fileItem.sharedWithUsers)) {
              fileItem.sharedWithUsers.forEach((user) => {
                if (user?.emailAddress && !emailMap.has(user.emailAddress)) {
                  emailMap.set(user.emailAddress, user);
                }
              });
            }
          }

          const allSharedUsers = Array.from(emailMap.values());
          this.setState({
            list: response,
            filteredList: response,
            allSharedUsers: allSharedUsers,
            selectKey: UtilService.uuidv4(),
          });
        }
      );
    } else {
      FileService.myFiles().then((response) => {
        let foldersList = _.filter(response, (item) => item.folder === true);
        let foldersWithItemCount = _.map(foldersList, (folder) => {
          let itemCount = _.filter(
            response,
            (item) => item.parentFolderId === folder.uniqueId
          ).length;
          return { ...folder, items: itemCount };
        });

        // Step 3: Set state
        this.setState({
          list: foldersWithItemCount,
          filteredList: foldersWithItemCount,
        });
      });
    }
  };

  componentDidMount() {
    this.loadData();

    // ContactService.list().then((response) => {
    //   this.setState({contactList: response});
    // });
  }

  hideDeleteAlert = () => {
    this.setState({
      alert: null,
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure?"
          onConfirm={() => this.delete(uniqueId)}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You won't be able to revert this!
        </ReactBSAlert>
      ),
    });
  };

  confirmUnShareAlert = (email) => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure?"
          onConfirm={() => this.unshare(email)}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, Un Share it!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You can re share again!
        </ReactBSAlert>
      ),
    });
  };

  confirmBulkUnShareAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure?"
          onConfirm={() => this.bulkUnShare()}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, Un Share All!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You can re share again!
        </ReactBSAlert>
      ),
    });
  };

  confirmBulkDeleteAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure you want to delete all these files?"
          onConfirm={() => this.bulkDelete()}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, Delete All!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You can not revert this!
        </ReactBSAlert>
      ),
    });
  };

  applyFilter = () => {
    const { list, filterName, filterCountry } = this.state;

    const filteredList = _.filter(list, (file) => {
      const nameMatches = filterName
        ? _.includes(_.toLower(file.name), _.toLower(filterName))
        : true;
      const emailMatches = this.state.selectedSharedUser
        ? Array.isArray(file.sharedWithUsers) &&
          file.sharedWithUsers.some(
            (user) =>
              _.toLower(user.emailAddress) ===
              _.toLower(this.state.selectedSharedUser?.emailAddress)
          )
        : true;

      // return nameMatches && countryMatches;
      return nameMatches && emailMatches;
    });

    this.setState({ filteredList: filteredList });
  };

  clearFilter = () => {
    this.setState({
      filteredList: this.state.list,
      filterName: null,
      filterCountry: null,
      selectedSharedUser: null,
      selectKey: UtilService.uuidv4(),
    });
  };

  displayContacts = (uniqueId) => {
    let filteredContacts = _.filter(
      this.state.contactList,
      (value) => value.company.uniqueId === uniqueId
    );
    this.setState({ filteredContacts: filteredContacts });
    this.toggleModal("contactModal");
  };

  delete(uniqueId) {
    this.setState({ alert: null });
    FileService.delete(uniqueId).then((response) => {
      this.notify("success", "SUCCESS", "Deleted Successfully");
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      this.loadData();
    });
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  showRenameModal = (fileItem) => {
    this.setState({ selectedFileItem: fileItem, newName: fileItem?.name });
    this.toggleModal("renameModal");
  };

  submitNewName = () => {
    const data = {
      newName: this.state.newName,
      uniqueId: this.state.selectedFileItem.uniqueId,
    };
    FileService.rename(data).then((response) => {
      this.toggleModal("renameModal");
      this.notify("success", "SUCCESS", `Renamed successfully!`);
      let oldList = _.filter(
        this.state.list,
        (item) => item.uniqueId !== response.uniqueId
      );
      let newList = [...oldList, response];
      this.setState({ list: newList, filteredList: newList });
    });
  };

  showShareModal = (fileItem) => {
    this.setState({ selectedFileItem: fileItem });
    this.toggleModal("shareModal");
  };

  submitShareWith = () => {
    this.setState({ loading: true });
    if (!this.state.isBulkShare && this.state.shareWith.length === 0) {
      this.notify("error", "ERROR", `Share with at least 1 email address!`);
      this.toggleModal("shareModal");
      this.setState({ loading: false });
    }

    if (this.state.isBulkShare && this.state.shareWith.length === 0) {
      this.notify("error", "ERROR", `Share with at least 1 email address!`);
      this.toggleModal("shareModal");
      this.setState({ isBulkShare: false, fileList: new Set() });
      this.setState({ loading: false });
    }

    if (this.state.isBulkShare && this.state.fileList.size === 0) {
      this.notify("error", "ERROR", `Select at least 1 file to share!`);
      this.toggleModal("shareModal");
      this.setState({ isBulkShare: false, fileList: new Set() });
      this.setState({ loading: false });
    }

    const data = {
      shareWith: this.state.shareWith,
      uniqueIds: this.state.isBulkShare
        ? [...this.state.fileList]
        : [this.state.selectedFileItem.uniqueId],
    };
    FileService.share(data).then((response) => {
      this.toggleModal("shareModal");
      this.notify(
        "success",
        "SUCCESS",
        `Shared successfully with ${data.shareWith.length} emails!`
      );
      this.setState({ loading: false });
      this.setState({ isBulkShare: false, fileList: new Set() });
      this.loadData();
    });
  };

  submitUnShareWith = () => {
    this.setState({ loading: true });
    if (this.state.unShareWith.length === 0) {
      this.notify("error", "ERROR", `Un Share with at least 1 email address!`);
      this.toggleModal("unShareModal");
      this.setState({ loading: false });
    }

    const data = {
      unShareWith: this.state.unShareWith,
      uniqueIds: [this.state.selectedFileItem.uniqueId],
    };
    FileService.unshareWithUsers(data)
      .then((response) => {
        this.toggleModal("unShareModal");
        this.notify(
          "success",
          "SUCCESS",
          `UnShared successfully with ${data.unShareWith.length} emails!`
        );
        this.setState({ loading: false });
        this.setState({ unShareWith: [], selectedFileItem: null });
        this.loadData();
      })
      .catch((reason) => {
        this.setState({ loading: false });
      });
  };

  addToShareWith = () => {
    const sharedWith = [...this.state.shareWith, this.state.share];
    this.setState({ shareWith: sharedWith, share: "" });
  };

  addToUnShareWith = () => {
    const unsharedWith = [...this.state.unShareWith, this.state.unShare];
    this.setState({ unShareWith: unsharedWith, unShare: "" });
  };

  showSharedModal = (fileItem) => {
    this.setState({
      sharedWithList: fileItem?.sharedWithUsers,
      selectedFileItem: fileItem,
    });
    this.toggleModal("viewSharedModal");
  };

  toggleFileSelection = (uniqueId) => {
    const { fileList } = this.state;
    let updatedFileList = new Set(fileList);

    if (updatedFileList.has(uniqueId)) {
      updatedFileList.delete(uniqueId);
    } else {
      updatedFileList.add(uniqueId);
    }

    this.setState({ fileList: updatedFileList });
  };

  handleUserChange = (valueObj) => {
    if (_.isNull(valueObj)) {
      this.setState({ selectedSharedUser: null });
    } else {
      this.setState({ selectedSharedUser: valueObj });
    }
  };

  bulkShare = () => {
    this.setState({ isBulkShare: true });
    this.toggleModal("shareModal");
  };

  unshare = (email) => {
    this.hideDeleteAlert();
    const data = {
      email: email,
      uniqueId: this.state.selectedFileItem?.uniqueId,
    };
    FileService.unshare(data).then((response) => {
      this.loadData();
      this.notify("success", "SUCCESS", `Successfully unshared file!`);
      this.setState({ sharedWithList: response?.sharedWithUsers });
    });
  };

  showItems = (uniqueId) => {
    let count =
      _.countBy(this.state.list, (item) => item?.parentFolderId === uniqueId) ||
      0;
    return count;
  };

  bulkUnShare = () => {
    this.hideDeleteAlert();
    this.setState({ loading: true });
    if (this.state.fileList.size === 0) {
      this.notify("error", "ERROR", `Select at least 1 file to unshare!`);
      this.setState({ loading: false });
      return;
    }

    if (this.state.selectedSharedUser === null) {
      this.notify("error", "ERROR", "Select a user from the filters!");
      this.setState({ loading: false });
      return;
    }

    const data = {
      unShareWith: Array.from(
        new Set().add(this.state.selectedSharedUser.emailAddress)
      ),
      uniqueIds: Array.from(this.state.fileList),
    };
    FileService.unshareWithUsers(data)
      .then((response) => {
        this.notify(
          "success",
          "SUCCESS",
          `Successfully  unshared ${data.uniqueIds.size} files!`
        );
        this.setState({ loading: false });
        this.setState({
          fileList: new Set(),
          selectedFileItem: null,
          selectedSharedUser: null,
        });
        this.loadData();
      })
      .catch((reason) => {
        this.setState({ loading: false });
      });
  };

  bulkDelete = () => {
    this.hideDeleteAlert();
    this.setState({ loading: true });
    if (this.state.fileList.size === 0) {
      this.notify("error", "ERROR", `Select at least 1 file to delete!`);
      this.setState({ loading: false });
      return;
    }

    const data = {
      uniqueIds: Array.from(this.state.fileList),
    };
    FileService.bulkDelete(data)
      .then((response) => {
        this.notify(
          "success",
          "SUCCESS",
          `Successfully  deleted ${data.uniqueIds.length} files!`
        );
        this.setState({ loading: false });
        this.setState({
          fileList: new Set(),
          selectedFileItem: null,
          selectedSharedUser: null,
        });
        this.loadData();
      })
      .catch((reason) => {
        this.setState({ loading: false });
      });
  };

  showUnShareModal = (fileItem) => {
    this.setState({ selectedFileItem: fileItem });
    this.toggleModal("unShareModal");
  };

  render() {
    let obj = this;
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {this.state.loading && <Loader />}
        <SimpleHeader
          name="My Drive"
          parentName="Drive"
          heading="XareGrwoth"
          // newBtnUrl="/admin/company/create"
          // newBtnText="Create Company"
        />
        {this.state.alert}
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">My Files and Folders</h3>
                    </div>
                  </Row>
                  {this.state.parentFolderId && (
                    <Row>
                      <p style={{ fontStyle: "italic", color: "gray" }}>
                        Use the filters below to narrow down your search
                        results.
                      </p>
                    </Row>
                  )}
                  <Row>
                    {/*<Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>*/}
                    {this.state.parentFolderId && (
                      <Col sm={12} md={3}>
                        <FormInput
                          name="filterName"
                          className="form-control-label"
                          id="companyName"
                          placeholder="File Name"
                          type="text"
                          onChange={this.onChange}
                          label="File Name"
                          value={this.state?.filterName || ""}
                          // errorMsg={this.props.errorObj?.name || ""}
                        />
                      </Col>
                    )}
                    {this.state.parentFolderId && (
                      <Col sm={12} md={3}>
                        <FormGroup>
                          <FormReactSelect
                            selectKey={this.state.selectKey}
                            isMulti={false}
                            className="form-control-label"
                            isSearchable={true}
                            label="Shared With user"
                            name={"selectSharedWithUser"}
                            onChange={this.handleUserChange}
                            optionValue={"value"}
                            defaultValue={this.state.selectedSharedUser}
                            optionList={this.state.allSharedUsers}
                            optionLabel={"fullName"}
                            placeHolder="Select Shared User"
                            errorMsg={this.state?.errorObj?.country || ""}
                          />
                        </FormGroup>
                      </Col>
                    )}
                    <Col sm={12} md={6} style={{ marginTop: "30px" }}>
                      <Row>
                        {this.state.parentFolderId && (
                          <Button
                            size="md"
                            outline
                            color="default"
                            type="button"
                            onClick={this.applyFilter}
                          >
                            Apply Filter
                          </Button>
                        )}
                        {this.state.parentFolderId && (
                          <Button
                            color="default"
                            size="md"
                            outline
                            type="button"
                            onClick={this.clearFilter}
                          >
                            Clear Filter
                          </Button>
                        )}

                        {this.state.parentFolderId && (
                          <FileUploadButton
                            onFilesSelected={this.getOnFilesSelected()}
                          />
                        )}

                        {this.state.parentFolderId && (
                          <Button
                            disabled={this.state.fileList.size === 0}
                            color="default"
                            size="md"
                            outline
                            type="button"
                            onClick={this.confirmBulkDeleteAlert}
                          >
                            <FaTrash style={{ marginRight: "8px" }} />
                            Delete Files
                          </Button>
                        )}
                      </Row>
                      <br />
                      <Row>
                        {this.state.parentFolderId && (
                          <Button
                            disabled={this.state.fileList.size === 0}
                            color="default"
                            size="md"
                            outline
                            type="button"
                            onClick={this.bulkShare}
                          >
                            <FaShare style={{ marginRight: "8px" }} />
                            Share Files
                          </Button>
                        )}
                        {this.state.parentFolderId && (
                          <Button
                            disabled={this.state.fileList.size === 0}
                            color="default"
                            size="md"
                            outline
                            type="button"
                            onClick={this.confirmBulkUnShareAlert}
                          >
                            <FaUserMinus
                              style={{ marginRight: "8px", color: "darkred" }}
                            />
                            UnShare Files
                          </Button>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                  <tr>
                    {obj.state.parentFolderId && (
                        <th className="sort" data-sort="name" scope="col">
                          <input
                              type="checkbox"
                              checked={
                                  obj.state.filteredList.length > 0 &&
                                  obj.state.filteredList?.every((contact) =>
                                      obj.state.fileList?.has(contact.uniqueId)
                                  )
                              }
                              onChange={(e) => {
                                const allSelected = e.target.checked;
                                const updatedFileList = new Set(
                                    obj.state.audienceList
                                );
                                if (allSelected) {
                                  obj.state.filteredList.forEach((contact) =>
                                      updatedFileList.add(contact.uniqueId)
                                  );
                                } else {
                                  obj.state.filteredList.forEach((contact) =>
                                      updatedFileList.delete(contact.uniqueId)
                                  );
                                }
                                obj.setState({fileList: updatedFileList});
                              }}
                          />{" "}
                          All
                        </th>
                    )}

                    <th className="sort" data-sort="name" scope="col">
                      #
                    </th>
                    <th scope="col"/>
                    <th className="sort" data-sort="budget" scope="col">
                      Date Created
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Name
                    </th>
                    {obj.state.parentFolderId && (
                        <th className="sort" data-sort="status" scope="col">
                          Shared with
                        </th>
                    )}
                    {!obj.state.parentFolderId && (
                        <th className="sort" data-sort="status" scope="col">
                          Items
                        </th>
                    )}

                  </tr>
                  </thead>
                  <tbody className="list">
                    {this.state.filteredList.map(function (value, index) {
                      return (
                          <tr key={index}>
                            {obj.state.parentFolderId && (
                                <td>
                                  <input
                                      type="checkbox"
                                      // disabled={value?.hotlisted}
                                      checked={obj.state.fileList.has(value.uniqueId)}
                                      onChange={() =>
                                          obj.toggleFileSelection(value.uniqueId)
                                      }
                                  />
                                </td>
                            )}

                            <td className="budget">{index + 1}</td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                    color=""
                                    size="sm"
                                    className="btn-icon-only text-light"
                                >
                                  <i className="fas fa-ellipsis-v"/>
                                </DropdownToggle>
                                <DropdownMenu
                                    className="dropdown-menu-arrow"
                                    right
                                    container={document.body}
                                >
                                  {value.folder && (
                                      <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            obj.props.history.push(
                                                `/${SecurityService.getLayout()}/drive/my-drive/${
                                                    value.uniqueId
                                                }`
                                            );
                                          }}
                                      >
                                        Open
                                      </DropdownItem>
                                  )}
                                  <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.showRenameModal(value);
                                      }}
                                  >
                                    Rename
                                  </DropdownItem>
                                  {!value.folder && (
                                      <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            downloadUtil.download({
                                              uniqueId: value.documentId,
                                              originalFileName: value.name,
                                            });
                                          }}
                                      >
                                        Download
                                      </DropdownItem>
                                  )}
                                  {!value.folder && (
                                      <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            obj.showShareModal(value);
                                          }}
                                      >
                                        Share
                                      </DropdownItem>
                                  )}
                                  {!value.folder && (
                                      <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            obj.showSharedModal(value);
                                          }}
                                      >
                                        UnShare
                                      </DropdownItem>
                                  )}
                                  <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.confirmDeleteAlert(`${value.uniqueId}`);
                                      }}
                                  >
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                            <td className="budget">
                              {formatFrontendDate(value.dateCreated)}
                            </td>
                            <td
                                className="budget"
                                style={{cursor: "grabbing"}}
                                onClick={() => {
                                  if (value.folder) {
                                    obj.props.history.push(
                                        `/${SecurityService.getLayout()}/drive/my-drive/${
                                            value.uniqueId
                                        }`
                                    );
                                  } else {
                                    downloadUtil.download({
                                      uniqueId: value.documentId,
                                      originalFileName: value.name,
                                    });
                                  }
                                }}
                            >
                              {value.folder && <FaFolder size={24}/>}{" "}
                              {!value.folder && (
                                  <FaFile size={24} color="#6c757d"/>
                              )}{" "}
                              {value.name}
                            </td>
                            {obj.state.parentFolderId && (
                                <td
                                    className="budget"
                                    onClick={() => obj.showSharedModal(value)}
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "blue",
                                    }}
                                >
                                  {value?.sharedWith?.length}
                                </td>
                            )}
                            {!obj.state.parentFolderId && (
                                <td className="budget">{value?.items}</td>
                            )}

                          </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>

          <Modal
              className="modal-dialog-centered modal-lg"
              isOpen={this.state.viewSharedModal}
              toggle={() => this.toggleModal("viewSharedModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Shared With
              </h6>
              <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("viewSharedModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <ModalBody>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                  <tr>
                    <th className="sort" data-sort="name" scope="col">
                      #
                    </th>
                    <th className="sort" data-sort="budget" scope="col">
                      Name
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Email Address
                    </th>
                    <th className="sort" data-sort="name" scope="col">
                      Actions
                    </th>
                    <th scope="col"/>
                  </tr>
                  </thead>
                  <tbody className="list">
                  {this.state.sharedWithList.map(function (value, index) {
                    return (
                        <tr key={index}>
                          <td className="budget">{index + 1}</td>
                          <td className="budget">{value?.fullName}</td>
                          <td className="text-right">{value?.emailAddress}</td>
                          <td className="text-right">
                            <Button
                                color={"gray"}
                                outline={true}
                                onClick={() =>
                                    obj.confirmUnShareAlert(value?.emailAddress)
                                }
                            >
                              UnShare
                            </Button>
                          </td>
                        </tr>
                    );
                  })}
                  </tbody>
                </Table>
              </ModalBody>
            </div>
            <div className="modal-footer">
              <Button
                  className="ml-auto"
                  outline
                  color="gray"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("viewSharedModal")}
              >
                Close
              </Button>
            </div>
          </Modal>

          <Modal
              className="modal-dialog-centered modal-lg"
              isOpen={this.state.renameModal}
              toggle={() => this.toggleModal("renameModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Rename
              </h6>
              <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => this.toggleModal("renameModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <ModalBody>
              <FormGroup>
                  <Label for="renameInput">New Name</Label>
                  <Input
                    id="renameInput"
                    name="newName"
                    type="text"
                    value={this.state.newName}
                    onChange={this.onChange}
                    placeholder="Enter new name"
                  />
                </FormGroup>
              </ModalBody>
            </div>
            <div className="modal-footer">
              <Button
                className="ml-auto"
                outline
                color="gray"
                data-dismiss="modal"
                type="button"
                onClick={() => this.submitNewName()}
              >
                Rename
              </Button>
              <Button
                className="ml-auto"
                outline
                color="gray"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("renameModal")}
              >
                Close
              </Button>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered modal-md"
            isOpen={this.state.shareModal}
            toggle={() => this.toggleModal("shareModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Share files with
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("shareModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <ModalBody>
                <Row>
                  <Col sm={10}>
                    <FormGroup>
                      <Label for="shareInput">Add email address</Label>
                      <Input
                        id="shareInput"
                        name="share"
                        type="email"
                        value={this.state.share}
                        onChange={this.onChange}
                        placeholder="eg: john@doe.com"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Button
                        className="ml-auto"
                        outline
                        style={{ top: "34px" }}
                        color="gray"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.addToShareWith()}
                      >
                        Add
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div>
                      {this.state.shareWith.map((value, index) => {
                        return <Badge color="secondary">{value}</Badge>;
                      })}
                    </div>
                  </Col>
                </Row>
              </ModalBody>
            </div>
            <div className="modal-footer">
              <Button
                className="ml-auto"
                outline
                color="gray"
                data-dismiss="modal"
                type="button"
                onClick={() => this.submitShareWith()}
              >
                Share
              </Button>
              {/*<Button
                    className="ml-auto"
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("shareModal")}
                >
                  Close
                </Button>*/}
            </div>
          </Modal>

          <Modal
            className="modal-dialog-centered modal-md"
            isOpen={this.state.unShareModal}
            toggle={() => this.toggleModal("unShareModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Un Share files with
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("unShareModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <ModalBody>
                <Row>
                  <Col sm={10}>
                    <FormGroup>
                      <Label for="shareInput">Add email address</Label>
                      <Input
                        id="shareInput"
                        name="unShare"
                        type="email"
                        value={this.state.unShare}
                        onChange={this.onChange}
                        placeholder="eg: john@doe.com"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={2}>
                    <FormGroup>
                      <Button
                        className="ml-auto"
                        outline
                        style={{ top: "34px" }}
                        color="gray"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.addToUnShareWith()}
                      >
                        Add
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  {this.state?.unShareWith.length !== 0 && (
                    <Col sm={12}>
                      <div>
                        UnShare With -{" "}
                        {this.state?.unShareWith?.map((value, index) => {
                          return (
                            <Badge
                              style={{ textTransform: "none" }}
                              color="danger"
                            >
                              {value}
                            </Badge>
                          );
                        })}
                      </div>
                    </Col>
                  )}
                  {this.state?.selectedFileItem && (
                    <Col sm={12}>
                      <div>
                        Shared With -{" "}
                        {this.state?.selectedFileItem?.sharedWith?.map(
                          (value, index) => {
                            return (
                              <Badge
                                key={UtilService.uuidv4()}
                                style={{ textTransform: "none" }}
                                color="success"
                              >
                                {value}
                              </Badge>
                            );
                          }
                        )}
                      </div>
                    </Col>
                  )}
                </Row>
              </ModalBody>
            </div>
            <div className="modal-footer">
              <Button
                className="ml-auto"
                outline
                color="gray"
                data-dismiss="modal"
                type="button"
                onClick={() => this.submitUnShareWith()}
              >
                UnShare
              </Button>
              {/*<Button
                    className="ml-auto"
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("shareModal")}
                >
                  Close
                </Button>*/}
            </div>
          </Modal>
        </Container>
      </>
    );
  }

  getOnFilesSelected() {
    return (files) => {
      const maxTotalSizeMB = 20;
      const totalSizeInBytes = files.reduce((acc, file) => acc + file.size, 0);
      const totalSizeInMB = totalSizeInBytes / (1024 * 1024);

      if (totalSizeInMB > maxTotalSizeMB) {
        this.notify(
          "error",
          "ERROR",
          `Total file size exceeds ${maxTotalSizeMB} MB. Please upload smaller files.`
        );
        return;
      }
      this.setState({ loading: true });
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("files", file); // keep name as 'files', not 'files[]'
      });
      formData.append("parentFolderId", this.state.parentFolderId);

      FileService.uploadFile(formData)
        .then((response) => {
          this.setState({ loading: false });
          this.loadData();
          this.notify("success", "SUCCESS", `File uploaded successfully.`);
          this.setState({
            files: [],
          });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });

      // handle upload or preview logic here
    };
  }
}

export default MyDrive;
